import React, { useState, useRef } from 'react';
import {
  CuentaDNI,
  Administra,
  Shorts,
  Seguridad2,
  Contacto1
} from 'components/articles';
import RicoData from './ricodata';
import Button from 'components/ui/button';
import './index.css';
import image from 'assets/images/main-adolescentes.jpg';



export default function Entre13y17() {
  const inputRef = useRef(null);
  const [article, setArticle] = useState(null);
  const variant = "adolescentes";

  const selectArticle = item => {
    setArticle(item);
    const scrollto = inputRef.current.getBoundingClientRect().top + window.scrollY - 150;
    window.scrollTo({ top: scrollto, behavior: 'smooth' });
  }

  return (
    <div className={`wrapper ${variant}`}>
      <div className="content-cols">
        <figure>
          <img src={image} alt="Tengo entre 13 y 17" />
          <figcaption>¿Tenés entre<br />13 y 17 años?</figcaption>
        </figure>
        <section className='segment-nav'>
          <Button
            article='cuenta-dni'
            active={article === 'cuenta-dni'}
            onclick={() => selectArticle('cuenta-dni')}
          />
          <Button
            article='administra'
            active={article === 'administra'}
            onclick={() => selectArticle('administra')}
            variant={variant}
          />
          <Button
            article='shorts'
            active={article === 'shorts'}
            onclick={() => selectArticle('shorts')}
          />
          <Button
            article='seguridad'
            active={article === 'seguridad'}
            onclick={() => selectArticle('seguridad')}
          />
          <Button
            article='contacto'
            active={article === 'contacto'}
            onclick={() => selectArticle('contacto')}
          />
        </section>
      </div>
      <div ref={inputRef}>
        {article &&
          <article>
            {article === 'cuenta-dni' && <CuentaDNI variant={variant} />}
            {article === 'administra' && <Administra variant={variant} />}
            {article === 'shorts' && <Shorts />}
            {article === 'seguridad' && <Seguridad2 />}
            {article === 'contacto' && <Contacto1 />}
          </article>
        }
      </div>
      <RicoData />
    </div>
  );
}